import { REACT_SELECT_NONCE } from '@anchorage/frontoffice/constants/app';
import { getAnchorageDocument } from '@anchorage/next';

export const CSP = {
  nonce: REACT_SELECT_NONCE,
};

export default getAnchorageDocument({ nonce: CSP.nonce });
